module.exports = __webpack_public_path__ + "img/6523e4f786080394d9e3d297_isae3000-type2.a7aee471.webp";